import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { OktaAuthService } from '@okta/okta-angular';
import { UserDataService } from '../../services/user/userData.service';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  constructor(
    private router: Router,
    public userDataService: UserDataService,
    public oktaAuth: OktaAuthService,
    ){}

  ngOnInit(){
    localStorage.clear();
    sessionStorage.clear();
    this.userDataService.userData$.subscribe((data: any)=>{
      if(data.isAuthenticated){
        this.router.navigate(['home']);
      }
    })
  }
  styleContainer(){
    if(localStorage.getItem('Token')){
      return {'background-color': '#fff'}
    }else{
      return {'background-color': '#000', 'color':'#fff'}
    }
  }
  login(){
    this.oktaAuth.loginRedirect('/home');
  }
}




// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts